import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';

import PropTypes from 'prop-types';

import Tooltip from './styled/tooltip';
import { CopyToClipboard } from '../libraries/helpers';

const useStyles = makeStyles(theme => ({
    root: {
    },
    highlight: {
        color: theme.palette.secondary.main,
    },
}));

const CopyText = ({ text, copy, className }) => {
    const classes = useStyles();
    const [highlight, setHighlight] = useState(false);

    const handleClipboard = (e, s) => {
        CopyToClipboard(copy || s);
        e.preventDefault();
        e.stopPropagation();
        setHighlight(true);
        setTimeout(() => setHighlight(false), 1100);
    };

    return (
        <Tooltip title={highlight ? `Copied: ${copy || text}` : 'Click to copy'}>
            <span onClick={e => handleClipboard(e, text)}
                className={clsx(className, {
                    [classes.highlight]: highlight,
                })}>
                {text}
            </span>
        </Tooltip>
    );
};
CopyText.propTypes = {
    text: PropTypes.string,
    copy: PropTypes.string, // optional copy text if different from display
    className: PropTypes.string,
};

export default CopyText;
